// Простая функция показа модального окна
function showCustomModal(title = '', value = '') {
  showTemplateModal({title, value});
}

// Функция показа модального окна с шаблоном
function showTemplateModal(data = {title: 'Title', value: 'Text here...'}, templateName = 'default', options = {}) {
  /**
   * Короткое обращение для вызова функции рендеринга html по шаблону
   * @param {object} data - объект с данными. Поле value может быть string, а может - массивом string
   * @param {string} template - шаблон Mustache, либо название шаблона для поиска в шаблонах, либо 'default' для использования шаблона по умолчанию
   * @param {object} options - объект с параметрами для всплывающего окна и вложенных шаблонов (при необходимости):
   * id - идентификатор 
   * classes - дополнительные классы
   * include_templates - массив объектов, содержаших вложенные шаблоны: {template_name: template_body}
   */
  globalStorage.getTemplateFile(templateName, false);
  const htmlTemplate = globalStorage.getTemplateFile(templateName) ?? globalStorage.templateStorage.default;
  const include_templates = {};
  let classes = templateName + '__window';

  if (Object.keys(options).length) {
    if (options.include_templates?.length) {
      for (const name of options.include_templates) {
        if (!globalStorage.getTemplateFile(name)) continue;
        include_templates[name] = globalStorage.getTemplateFile(name);
      }
    }

    if (typeof options.classes !== 'undefined')
      classes = [...(Array.isArray(options.classes) ? options.classes : [options.classes]), classes];
  }

  options = $.extend({}, options, {templateName, template: htmlTemplate, data, include_templates, classes});

  (new CPopup)
    .setParams(options)
    .showPopup();
}

// Глобального хранилище для различных данных
var globalStorage = {
  checkedBoxes: 0,
  windowInnerWidthBreakPoint: 769,
  // Объект хранения коллбек-функций
  callbacks: {},
  // Массив хранения имен модулей для переназначения обработчиков
  handlers: [],
  // Вызов функций переназначения обработчиков для модулей
  handlersReset: function() {
    for (const module of this.handlers) {
      app[module].resetHandlers();
    }
  },
  // Шаблоны по умолчанию
  templateStorage: {
    default: '{{#title}}<h3>{{title}}</h3>{{/title}}{{#value}}<p>{{.}}</p>{{/value}}',
    html: '{{html}}'
  },
  /**
   * Взять шаблон на сайте и сохранить в памяти
   * @param {string} name - имя шаблона или непосредственно шаблон
   * @param {boolean} returnTemplate - вернуть шаблон (true) или просто сохранить его
   * @returns string|boolean
   */
  getTemplateFile: function getTemplateFile(name, returnTemplate = true) {
    if (name.includes('{{')) {
      return name;
    } else if (typeof globalStorage.templateStorage[name] !== 'undefined') {
      return returnTemplate ? globalStorage.templateStorage[name] : true;
    } else {
      $.ajax({
        url: window.TEMPLATE_PATH + '/js-templates/' + name + '.tpl.html',
        dataType: 'html',
        async: false,
      }).done(result => {
        globalStorage.templateStorage[name] = result;
        return returnTemplate ? globalStorage.templateStorage[name] : true;
      }).fail((jqXHR, textStatus) => {
        console.log(`No template with name ${name} found.`);
        console.log('Error: ' + textStatus);
        return false;
      })
    }
  }
};

window.initApps = function () {
  $('[data-app]').each(function (index, item) {
    var $this = $(item);
    var split = $this.data('app').split('||');
    $.each(split, function (appIndex, appName) {
      var appNameCamel = false;
      if (appName.indexOf('-') !== -1) {
        appNameCamel = appName.replace(/(\x2D|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])((?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/g, function (m) {
          return m.toUpperCase();
        }).replace(/\x2D/g, '');
      }
      if (app[appName] && $this.data("".concat(appName, "-init")) !== true) {
        app[appName].init($this);
        $this.data("".concat(appName, "-init"), true);
      } else if (app[appNameCamel] && $this.data("".concat(appName, "-init")) !== true) {
        app[appNameCamel].init($this);
        $this.data("".concat(appName, "-init"), true);
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', function() {
  // Инициализация модулей
  app.global.init();
  initApps();
})

// Общие модули страницы
var app = {
  events: {},
  // Инициализация общих модулей
  global: {
    init: function init() {
      app.toolTip.init();
      app.popupWin.init();
      app.tabselector.init();
    }
  },
  // Селектор вкладок
  tabselector: {
    options: [],
    init: function init() {
      $(document).on('click', '.js-tabswitcher', function(event) {
        if (!$('.js-tabswitcher').is(event.target)) return;

        let toggleStatus = false;
        const tabGroup = $(this).data('tabgroup');
        const tab = $(this).data('tab');
        $(`.js-tabswitcher[data-tabgroup="${tabGroup}"]`).each((i, el) => {
          if ($(el).data('tab') === tab) {
            $(el).addClass('active');
            if (!toggleStatus && $(el).is('[data-toggle]')) {
              toggleStatus = $(el).data('toggle');
            }
          } else {
            $(el).removeClass('active');
          }
        })
        if (toggleStatus === 'add') {
          $('main').addClass('toggle-status');
        } else if (toggleStatus === 'remove') {
          $('main').removeClass('toggle-status');
        }
      })
    },
  },
  // Всплывающие окна
  popupWin: {
    init: function init() {
      this.setHandlers();

      $(document).on('click', '.js-popup-close', function(event){
        if (app.popupWin.preventClose || !$('.js-popup-close').is(event.target)) return;

        const popup = $(this).parents('.popup-win').get(0);
        $(popup).animate({opacity: 0}, 200, function(){
          $(popup).removeClass().addClass('popup-win');
          if ($(popup).is('[data-clear]')) $(popup).find('.popup-win__inner').html('');
          app.popupWin.scrollWindowPreventer(false);
          app.popupWin.preventClose = false;
        });
      })
    },
    setHandlers: function setHandlers(){
      document.addEventListener('click', function(event){
        if ($('.js-tt-popup').is(event.target) || $(event.target).parents('.js-tt-popup').length) {
          $('.js-tooltip.tooltipstered').tooltipster('close');
          const eventElement = $(event.target.classList?.contains('js-tt-popup') ? event.target : event.target.closest('.js-tt-popup'));
          if ('customevent' in eventElement.data()) {
            // Если элемент предполагает генерацию пользовательского события
            document.dispatchEvent(
              new CustomEvent(eventElement.data('customevent'),
                {detail: {itemId: eventElement.data('itemid')}}
              )
            )
            return;
          } else if ('popup' in eventElement.data()) {
            // Если элемент предполагает открытие модалки
            app.popupWin.showPopup({innerHTML: eventElement.data('popup'), classes: 'popup__window'});
          }
        }
      })
    },
    showPopup: function showPopup(options) {
      if (!('innerHTML' in options && options.innerHTML)
        && !('data' in options && options.data)
      ) return;

      (new CPopup)
        .setParams(options)
        .showPopup();
    },
    // Компенсация ширины полосы прокрутки
    scrollWindowPreventer: function scrollWindowPreventer(disableScroll = true) {
      isTouchDevice = !!('ontouchstart' in window || navigator.maxTouchPoints) && window.innerWidth < 769;
      const body = document.querySelector('body');
      let scrollWidth = 0;
      if (disableScroll) {
        this.scrollCounter += 1;
        scrollWidth = `${window.innerWidth - body.clientWidth}px`;
        body.classList.add('body_modal');
      } else {
        this.scrollCounter -= 1;
        if (this.scrollCounter > 0 || $('.popup-win.active').length > 0) return;
        body.classList.remove('body_modal');
        this.scrollCounter = 0;
      }
      if (!isTouchDevice) body.style.paddingRight = scrollWidth;
    }
  },
  // Всплывающие подсказки
  toolTip: {
    tooltipEnabled: true,
    popupCounter: 0,
    tooltipOptions: {
      animationDuration: 25,
      delay: 25,
      contentAsHTML: true,
      interactive: true,
      repositionOnScroll: true,
      debug: false,
      zIndex: 99999,
      /* trigger: 'click', */
      functionBefore: function(instance, helper) {
        if (typeof $(helper.origin).data('tooltip') === 'undefined') return;
        let tooltip = `<div class="tooltip__box tooltip__simple">${ $(helper.origin).data('tooltip') }</div>`;
        if (typeof $(helper.origin).data('popup') !== 'undefined') {
          tooltip = `<div class="tooltip__box tooltip-with-popup">${$(helper.origin).data('tooltip')}<div class="tooltip-popup js-tt-popup" data-popup="` + $(helper.origin).data('popup') + '">Подробнее</div></div>';
        }
        instance.content( tooltip );
        if (window.innerWidth < globalStorage.windowInnerWidthBreakPoint) {
          return false;
        }
      }
    },
    init: function init() {
      globalStorage.tooltips = [];
      this.setHandlers();

      app.toolTip.mobileClickHandler();

      this.tooltipEnabled = window.innerWidth < globalStorage.windowInnerWidthBreakPoint;
      app.toolTip.tooltipEnabler();
      $(window).on('resize', function(){
        app.toolTip.tooltipEnabler();
      })
    },
    tooltipEnabler: function tooltipEnabler() {
      if (window.innerWidth < globalStorage.windowInnerWidthBreakPoint && this.tooltipEnabled) {
        $('.js-tooltip.tooltipstered').tooltipster('disable');
        this.tooltipEnabled = false;
      } else if (window.innerWidth >= globalStorage.windowInnerWidthBreakPoint && !this.tooltipEnabled) {
        $('.js-tooltip.tooltipstered').tooltipster('enable');
        this.tooltipEnabled = true;
      }
    },
    setHandlers: function setHandlers() {
      $('body').on('mouseenter', '.js-tooltip:not(.tooltipstered)', function(event){
        $(this)
          .tooltipster(app.toolTip.tooltipOptions)
          .tooltipster('open');
      });
    },
    mobileClickHandler: function mobileClickHandler() {
      document.addEventListener('click', function(event){
        const eventElement = $(event.target.classList?.contains('js-tooltip') ? event.target : event.target.closest('.js-tooltip'));
        if (eventElement) {
          if (window.innerWidth >= globalStorage.windowInnerWidthBreakPoint || eventElement.hasClass('js-tt-popup')) return;

          let classes = eventElement.data('popup') ? 'popup__window' : 'tooltip__window';
          let innerHTML = eventElement.data('popup') ?? eventElement.data('tooltip');
          
          app.popupWin.showPopup({innerHTML, classes});
        }
      })
    }
  },
  // Обработчик выпадающих списков
  select: {
    minimumResultsForSearch: 10,
    init: function init() {
      if (!globalStorage.setSelect2) {
        this.resetHandlers();
        globalStorage.setSelect2 = true;
        // globalStorage.handlers.push('select');
      }
    },
    resetHandlers: function resetHandlers($id = '') {
      const selector = $id === '' ? '[data-app="select"]' : `#${$id}`;
      $(`${selector}`).find('select').select2({
        minimumResultsForSearch: app.select.minimumResultsForSearch // Infinity - если без поиска
      });
      $(`${selector}`).find('select').on('select2:open', function(e) {
        const searchInput = document.querySelector('.select2-search--dropdown');
        searchInput.dataset.placeholder = $(e.target).data('placeholder');
        searchInput.classList.add('show-placeholder');
        searchInput.querySelector('input').addEventListener('input', function(e){
          if ($(e.target).val() !== '') {
            $(e.target).parent().removeClass('show-placeholder');
          } else {
            $(e.target).parent().addClass('show-placeholder');
          }
        })
        if ($(e.target).find('option').length >= app.select.minimumResultsForSearch) {
          $(e.target).parent().addClass('select-search__enabled');
        }
      })
    }
  }
}
